module.exports = "/images/error-document.svg?5056389581c12ce27dd255f65bad88a4";